import { createPortal } from 'react-dom';

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
}) {
  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div className="admin-dashboard-overlay confirm-dialog-overlay" onClick={onCancel} role="presentation">
      <div
        className="confirm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-message"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="confirm-dialog-title" className="confirm-dialog-title">
          {title}
        </h2>
        {message ? (
          <p id="confirm-dialog-message" className="confirm-dialog-message">
            {message}
          </p>
        ) : null}
        <div className="confirm-dialog-actions">
          <button type="button" className="add-user-btn add-user-btn--ghost" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className="add-user-btn add-user-btn--primary" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
